<template>
  <HyperLink tabindex="-1" :to="`/results/${id}`">
    <LcCard
      body-class="inline-block pt-100"
      class="results-list-item"
      footer-class="flex items-center justify-between pb-100"
    >
      <template #header>
        <LcLotteryLogo
          class="my-050"
          v-bind="{ lotteryId }"
          :licensed-territory="lotteryConfig.licensedTerritory"
        />
      </template>

      <template #footer>
        <time class="flex items-center gap-200 text-capitalize" :datetime="drawDate">
          <IconWithCaption
            :caption="formatDate(drawDate, 'fullDate', timeZone, locale)"
            icon="calendar"
          />
          <LotteryDrawLabel v-if="hasMultipleDrawsOnDay" v-bind="{ label }" />
        </time>

        <LcButton
          class="-mr-150"
          icon="arrow-right"
          icon-position="right"
          no-padding
          size="small"
          variant="tertiary"
        >
          {{ $t('results.listitem.button.details') }}
        </LcButton>
      </template>

      <LineItem
        v-for="drawnNumber of drawnNumbers"
        v-bind="{ lotteryId }"
        :key="drawnNumber.name"
        :add-ons="lotteryConfig.currentConfig.addOns"
        class="line-item"
        :fields="getLotteryNumberFields(drawnNumber.numbers)"
        highlight-add-on
        :licensed-territory="lotteryConfig.licensedTerritory"
      />
    </LcCard>
  </HyperLink>
</template>

<script lang="ts" setup>
import type {
  DrawLabel,
  LotteryId,
  ReformattedDrawnNumbers,
} from '#api/shared/@types/generated/backend/graphql-schema-types'

import type { LineItemAddOn } from '../../../../../../app/components/LineItem/LineItem.vue'

type ResultsListItemDrawnNumbers = Pick<ReformattedDrawnNumbers, 'name' | 'numbers'>

type ResultsListItemLotteryConfig = {
  currentConfig: {
    addOns: LineItemAddOn[]
  }
  licensedTerritory: string
}

type ResultsListItemProps = {
  drawDate: string
  drawnNumbers: ResultsListItemDrawnNumbers[]
  hasMultipleDrawsOnDay: boolean
  id: string
  label: DrawLabel
  lotteryConfig: ResultsListItemLotteryConfig
  lotteryId: LotteryId
  timeZone?: string
}

defineProps<ResultsListItemProps>()

const { locale } = useI18n()
</script>

<style lang="scss" scoped>
.results-list-item {
  .line-item {
    padding: token('size/space/gap/100') token('size/space/gap/none');
    border-bottom: token('size/border/100') solid token('color/border/secondary/secondary-bold');

    &:first-of-type {
      padding-top: token('size/space/gap/none');
      padding-bottom: token('size/space/gap/100');
    }

    &:last-of-type {
      padding-bottom: token('size/space/gap/none');
      border-bottom: token('size/space/gap/none');
    }
  }
}
</style>
